export default __webpack_public_path__ + "static/logos_org-19641b49f637ff055b198d59e76bc912.png";